var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPhotoProfile)?_c('img',{staticClass:"img-thumbnail object-cover rounded-circle",class:_vm.sizeClass,attrs:{"src":_vm.userPhoto}}):_c('img',{staticClass:"img-thumbnail object-cover rounded-circle",class:_vm.sizeClass,attrs:{"src":_vm.photo}})
}
var staticRenderFns = []

export { render, staticRenderFns }